import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import AuthRoutes from "./AuthRoutes";
import Register from "../../containers/SignUp";
import Personalize from "../../containers/SignUp/personalize";
import SignIn from "../../containers/SignIn";
import ResetPassword from "../../containers/SignIn/restPassword";
import SetPassword from "../../containers/SignIn/setPassword";
import Not_found from "../../containers/SignUp/not_found";
import Newpassword from "../../containers/SignIn/newpassword";

class Routes extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const { storeName } = this.props;
    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          {!this.props.isAuthenticated ? (
            <React.Fragment>
              <Switch>
                <Route exact path="/404" component={Not_found} />
                <Route exact path="/register" component={Register} />
                <Route exact path="/profile" component={Personalize} />
                <Route exact path="/setpassword" component={SetPassword} />
                <Route exact path="/forgot" component={ResetPassword} />
                <Route exact path="/reset_password" component={Newpassword} />
                <Route exact path="/signin" component={SignIn} />
                <Route path="*" render={() => <Redirect to="/signin" />} />
              </Switch>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Switch>
                <Route path="/" component={AuthRoutes} />
              </Switch>
            </React.Fragment>
          )}
        </Switch>
      </Suspense>
    );
  }
}

export default connect((storeState) => {
  return {
    isAuthenticated: storeState.AuthReducer?.isAuthenticated,
    storeName: storeState.AuthReducer.storeInfo,
  };
})(Routes);
